import { print } from 'graphql';

import findCreateManyTagMutation from '~/shared/graphql-queries/tags/find-create-many-tag-mutation';
import findManyTagQuery from '~/shared/graphql-queries/tags/find-many-tag-query';
import type { BuilderType } from '~/types';

type FindCreateManyTagArgs = Readonly<{
  names?: string[];
  type?: string;
  language?: string;
}>;

type FindManyTagArgs = Readonly<{
  filter?: {
    type?: string;
    language?: string;
  };
}>;

export const tagsTagTypes = ['tags'] as const;

export const getTagsQuery = (builder: BuilderType) => {
  return {
    findCreateManyTag: builder.mutation<unknown, FindCreateManyTagArgs>({
      invalidatesTags: ['tags'],
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: findCreateManyTagMutation.loc?.source?.body,
          variables: {
            names: args?.names,
            type: args?.type,
            language: args?.language,
          },
        }),
      }),
    }),

    findManyTag: builder.query<unknown, FindManyTagArgs>({
      providesTags: ['tags'],
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findManyTagQuery),
          variables: {
            filter: args?.filter,
          },
        }),
      }),
    }),
  };
};
